import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import { AnimationBase } from '../animation-base';

@Component({
  selector: 'mdw-collapse',
  templateUrl: './collapse.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./collapse.scss'],
})
export class MdwCollapse extends AnimationBase {
  public readonly isCollapsed = input.required<boolean>();
  public readonly orientation = input<'vertical' | 'horizontal'>('vertical');

  protected readonly enterClass = computed(() => {
    return this.orientation() === 'vertical'
      ? 'mdw-collapse-enter-vertical'
      : 'mdw-collapse-enter-horizontal';
  });

  protected readonly leaveClass = computed(() => {
    return this.orientation() === 'vertical'
      ? 'mdw-collapse-leave-vertical'
      : 'mdw-collapse-leave-horizontal';
  });
}
